<template>
  <div>
    <CRow>
      <CCol col="12" xl="12">
        <CCard>
          <CCardHeader>
            <CButton color="success" @click="newLink" class="float-right">
              <CIcon name="cilPlus" />
              New Link
            </CButton>
            <h4>Links</h4>
          </CCardHeader>
          <CCardBody>
            <CAlert color="secondary" closeButton>
              <CIcon name="cil-lightbulb"/>
              <span class="pl-2">Links are a special type of item that can contain a link to a screen, block, podcast or episode.</span>
            </CAlert>
            <CInput v-model="search" placeholder="Search links" class="mt-2 mb-4">
              <template #prepend-content><CIcon name="cil-magnifying-glass"/></template>
            </CInput>
            <CDataTable hover striped :items="items" :fields="fields" clickable-rows @row-clicked="rowClicked">
              <template #edit="">
                <td>
                  <CIcon name="cil-arrow-right" />
                </td>
              </template>
            </CDataTable>
            <CPagination
              v-if="pages > 1"
              align="center"
              :active-page="activePage"
              v-on:update:activePage="pageChange"
              :pages="pages"
              :dots="false"
            />
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'Links',
  data() {
    return {
      items: [],
      fields: [
        { key: 'id' },
        { key: 'title', _classes: 'font-weight-bold' },
        { key: 'entity_type' },
        { key: 'entity_id' },
        { key: 'edit', label: ' ' },
      ],
      limit: 10,
      pages: 1,
      search: '',
    }
  },
  watch: {
    activePage() {
      this.getData()
    },
    search: {
      handler() {
        this.triggerSearch()
      },
    },
  },
  mounted() {
    this.getData()
  },
  destroyed() {
    this.$store.dispatch('closeError')
  },
  computed: {
    activePage() {
      const { query } = this.$route
      return query && query.page ? Number(query.page) : 1
    },
  },
  methods: {
    rowClicked(item) {
      this.$router.push({ path: `links/${item.id}` })
    },
    newLink() {
      this.$router.push({ path: `links/0` })
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } })
    },
    getData() {
      this.$api
        .get(`links/?q=${this.search}&limit=${this.limit}&page=${this.activePage}`)
        .then(response => {
          response.data.links.map(e => (e.edit = true))
          this.items = response.data.links
          this.pages = Math.ceil(response.data.total / this.limit)
        })
        .catch(error => this.$store.dispatch('throwError', error))
    },
    triggerSearch: _.debounce(function() {
      this.getData()
    }, 500),
  },
}
</script>
